import * as yup from 'yup'

const LOWER_CASE_LETTERS = /[a-z]/
const UPPER_CASE_LETTERS = /[A-Z]/
const SPECIAL_CHARACTERS = /(=|\+|-|\^|\$|\*|\.|\[|\]|\{|\}|\(|\)|\?|"|!|@|#|%|&|\/|\\|,|>|<|'|:|;|\||_|~|`)/
const NUMBERS = /\d/

const passwordValidation = yup.string()
  .test('hasLowerCase', 'Password must contain a lower case letter', (value) => value.match(LOWER_CASE_LETTERS))
  .test('hasUpperCase', 'Password must contain an upper case letter', (value) => value.match(UPPER_CASE_LETTERS))
  .test('hasSpecialCharacter', 'Password must contain a special character', (value) => value.match(SPECIAL_CHARACTERS))
  .test('hasNumber', 'Password must contain a number', (value) => value.match(NUMBERS))
  .test('length', 'Password must contain at least 8 characters', (value) => value.length >= 8)

const formSchema = yup.object().shape({
  firstName: yup.string().required('First name is required'),
  lastName: yup.string().required('Last name is required'),
  email: yup.string().email('Please enter a valid email address').required('Email is required'),
  birthdate: yup.date().typeError('Account Owner Date of Birth must be a valid date').required('Account Owner Date of Birth is required'),
  password: passwordValidation.required('Password is required'),
  agreeToTOS: yup.bool().test('agreeToTOS', 'Please check this box to continue', (value) => value === true),
})

export { formSchema, passwordValidation }
